import { TextProps, Text as MantineText } from '@mantine/core';
import cn from 'classnames';
import { PropsWithChildren } from 'react';
import * as React from 'react';

import { getAdaptiveWeight } from './getAdaptiveWeight';

import s from './Text.module.scss';

type Props = PropsWithChildren &
  TextProps & {
    component?: 'div' | 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    dangerouslySetInnerHTML?: { __html: string };
  };

const isWindows = typeof navigator !== 'undefined' && navigator.userAgent.includes('Windows');

const Text: React.FC<Props> = ({ children, fw, td, component, className, ...props }) => {
  const adaptiveFw = isWindows ? getAdaptiveWeight(fw) : fw;
  const isUnderline = td === 'underline';

  return (
    <MantineText
      component={component}
      {...props}
      fw={adaptiveFw}
      td={td}
      className={cn(isUnderline && s.root__underline, className)}
    >
      {children}
    </MantineText>
  );
};

export default Text;
